<template>
    <p>Error 404: not found</p>
</template>
